import { useLocalStorage } from 'react-use';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
const SIMILARITY_ALIGNMENT_KEY = 'similarity-alignment-enabled';
const useSimilarityAlignment = () => {
    const { hasPermission } = useUser();
    const canUseSimilarity = hasPermission(Permissions.VIEW_SIMILARITY_ALIGNMENT);
    const [enabled, setEnabled] = useLocalStorage(SIMILARITY_ALIGNMENT_KEY, true);
    return [
        canUseSimilarity && (enabled !== null && enabled !== void 0 ? enabled : true),
        (value) => setEnabled(value),
        canUseSimilarity,
    ];
};
export default useSimilarityAlignment;
